import {PRIMATOO_BASE_PROD_ENVIRONMENT} from '@pt/pt-core';

export const environment = {
  ...PRIMATOO_BASE_PROD_ENVIRONMENT,
  production: true,
  appId: 'primatoo-ui',
  logLevel: 'OFF',
  connectionAttempts: 5,
};
